import React from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import { I as InfoIcon } from '../InfoIcon-3d2fa1da.js';
import '../Icons/InfoIcon.js';

var css_248z = ".lovHb{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;font-family:inherit;font-size:14px;gap:5px}.kun27{fill:var(--ricos-settings-icons-color,#000);height:24px;width:24px}[dir] .kun27{cursor:pointer}";
var styles = {"label":"lovHb","label_icon":"kun27"};
styleInject(css_248z);

const Label = ({
  label,
  tooltipText,
  children,
  iconStyles,
  style,
  isMobile,
  forceTooltipVisibility
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.label, style }, /* @__PURE__ */ React.createElement("span", null, label), !isMobile && !tooltipText ? null : children ? /* @__PURE__ */ React.createElement(Tooltip, { content: tooltipText }, children) : !isMobile && /* @__PURE__ */ React.createElement(
    InfoIcon,
    {
      tooltipText,
      iconStyles: iconStyles || styles.label_icon,
      forceVisibility: forceTooltipVisibility
    }
  ));
};

export { Label as default };
//# sourceMappingURL=Label.js.map
